var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('SunpodStationAreasIndex',{attrs:{"hidePlusButton":_vm.$acl.canNotCreate('Sun Pod Areas')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }